module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Maps"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("List of Maps")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#fig2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disposition of German Panzer-Division and Soviet Tank/Mechanized Corps on 1 January 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#fig2_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LVII Panzerkorps stand north of the Manych River, 5–11 January 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#fig2_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ostrogozhsk-Rossosh Operation, 13–31 January 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#fig2_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advance of Hoth’s Panzerarmee 4 on first day of "), _c('i', [_vm._v("Zitadelle")]), _vm._v(", 5 July 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#fig2_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation "), _c('i', [_vm._v("Rumyantsev")]), _vm._v(", the breakthrough of 1st Tank Army and 5th Guards Tank Army, 8 August 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#fig2_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle of Bogodukhov, 13–16 August 1943, "), _c('i', [_vm._v("Totenkopf")]), _vm._v(" vs. the 1st Tank Army")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#fig2_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soviet breakout from the Lyutezh Bridgehead and liberation of Kiev, 3–5 November 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#fig3_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German Effort to relieve the Korsun Pocket, 1–16 February 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#fig3_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Battle of Tirgu Fromos, 2 May 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#fig3_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advance of Soviet tank armies during Operation Bagration and Lvov-Sandomierz Offensive, June–July 1944")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74955de2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Maps.vue
// module id = 69
// module chunks = 0